module.exports = __webpack_public_path__ + "img/title.f6c2d6ab.png";